import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon, BackdropLoader, toast } from '@livable/saas-react-components';
import { TextField, ToggleButton, ToggleButtonGroup, Typography, Alert, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { PortfolioAccordionItem } from '../AddTeamMemberV2Modal/PortfolioAccordionItem';
import { arrayDiff } from 'src/utils/arrayHelpers';
import { USER_ROLES_BY_NAME } from 'src/constants/userSetting';
import warningImg from 'src/img/warning.svg';
export const RoleAndAccessContentModalContent = observer(_ref => {
  var _dataMember$propertyA, _dataMember$portfolio, _portfoliosData$filte;
  let dataMember = _ref.dataMember,
    handleModalClose = _ref.handleModalClose,
    triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    portfoliosData = _useState6[0],
    setPortfoliosData = _useState6[1];
  const _useState7 = useState((dataMember === null || dataMember === void 0 || (_dataMember$propertyA = dataMember.propertyAccessResponse) === null || _dataMember$propertyA === void 0 ? void 0 : _dataMember$propertyA.map(i => i.id)) || []),
    _useState8 = _slicedToArray(_useState7, 2),
    grantedProperties = _useState8[0],
    setGrantedProperties = _useState8[1];
  const _useState9 = useState((dataMember === null || dataMember === void 0 || (_dataMember$portfolio = dataMember.portfolioAccessResponse) === null || _dataMember$portfolio === void 0 ? void 0 : _dataMember$portfolio.map(i => i.id)) || []),
    _useState0 = _slicedToArray(_useState9, 2),
    grantedPortfolios = _useState0[0],
    setGrantedPortfolios = _useState0[1];
  const handleGrantAccess = (propertyId, portfolioId) => {
    if (!!propertyId) {
      var _portfolioData$proper;
      const portfolioData = portfoliosData.find(portfolio => portfolio.id === portfolioId);
      if ((portfolioData === null || portfolioData === void 0 || (_portfolioData$proper = portfolioData.properties) === null || _portfolioData$proper === void 0 ? void 0 : _portfolioData$proper.length) === 0) {
        return false;
      }
      let updatedPropertiesList;
      const matchingItemIndex = grantedProperties !== null && !!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length) ? grantedProperties.findIndex(item => item === propertyId) : -1;
      if (portfolioData !== null && portfolioData !== void 0 && portfolioData.id && grantedPortfolios.findIndex(i => portfolioData.id === i) !== -1) {
        setGrantedPortfolios([...grantedPortfolios.filter(id => id !== portfolioId)]);
        setGrantedProperties([...grantedProperties, ...(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.properties.map(i => i.propertyId).filter(i => i !== propertyId))]);
        return;
      }
      if (matchingItemIndex === -1) {
        if (grantedProperties === null || !(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length)) {
          updatedPropertiesList = [propertyId];
        } else if (!!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length)) {
          updatedPropertiesList = [...grantedProperties, propertyId];
        }
        setGrantedProperties([...updatedPropertiesList]);
        const someRes = arrayDiff(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.properties.map(i => i.propertyId), updatedPropertiesList);
        if ((someRes === null || someRes === void 0 ? void 0 : someRes.length) === 0) {
          const matchingItemIndexFix = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
          if (matchingItemIndexFix === -1) {
            if (grantedPortfolios === null || !(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
              setGrantedPortfolios([portfolioId]);
            } else if (!!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
              setGrantedPortfolios([...grantedPortfolios, portfolioId]);
            }
          } else {
            setGrantedPortfolios([...grantedPortfolios.filter(id => id !== portfolioId)]);
          }
          setGrantedProperties([...grantedProperties.filter(id => !(portfolioData !== null && portfolioData !== void 0 && portfolioData.properties.map(i => i.propertyId).includes(id)))]);
        }
      } else {
        setGrantedProperties([...grantedProperties.filter(id => id !== propertyId)]);
      }
    }
    if (!!portfolioId && !propertyId) {
      const matchingItemIndex = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
      if (matchingItemIndex === -1) {
        if (grantedPortfolios === null || !(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
          setGrantedPortfolios([portfolioId]);
        } else if (!!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
          setGrantedPortfolios([...grantedPortfolios, portfolioId]);
        }
        // NOTE: clear portfolio related properties
        if (grantedProperties && !!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length)) {
          const portfolioData = portfoliosData.find(portfolio => portfolio.id === portfolioId);
          setGrantedProperties([...grantedProperties.filter(id => !(portfolioData !== null && portfolioData !== void 0 && portfolioData.properties.map(i => i.propertyId).includes(id)))]);
        }
      } else {
        setGrantedPortfolios([...grantedPortfolios.filter(id => id !== portfolioId)]);
      }
    }
  };
  const getIsAccessGranted = function () {
    let propertyId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let portfolioId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (propertyId === null && portfolioId) {
      const matchingItemIndex = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
      return matchingItemIndex !== -1;
    }
    if (propertyId) {
      const matchingPortfolioItemIndex = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
      if (matchingPortfolioItemIndex !== -1) {
        return true;
      }
      const matchingItemIndex = grantedProperties !== null && !!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length) ? grantedProperties.findIndex(item => item === propertyId) : -1;
      return matchingItemIndex !== -1;
    }
  };
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
  };
  const _useState1 = useState((dataMember === null || dataMember === void 0 ? void 0 : dataMember.userRole) || USER_ROLES_BY_NAME.PropertyManagerAccountHolder),
    _useState10 = _slicedToArray(_useState1, 2),
    userRole = _useState10[0],
    setUserRole = _useState10[1]; // NOTE: PropertyManagerAccountHolder || PropertyManagerRegular

  const fetchPortfolios = async () => {
    const resp = await store.portfolios.getPortfoliosDashboardAsync.run();
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      setPortfoliosData(resp === null || resp === void 0 ? void 0 : resp.response.portfolios);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    await fetchPortfolios();
    setIsLoading(false);
  };
  const handleSubmit = async event => {
    event.stopPropagation();
    const setTeamMemberAccessSettings = await store.account.setTeamMemberAccessAsync.run({
      accountId: dataMember.accountId,
      userRole: userRole,
      propertyIds: grantedProperties,
      portfolioIds: grantedPortfolios
    });
    if (!setTeamMemberAccessSettings || !setTeamMemberAccessSettings.isSuccessful) {
      return;
    }
    toast('success', {
      body: ['Successfully Saved!']
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    triggerRefresh && triggerRefresh();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    handleModalClose && handleModalClose();
  };
  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.roleSelector
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, 'Role: '), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: userRole,
    size: "small",
    exclusive: true,
    onChange: (e, value) => setUserRole(value)
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: USER_ROLES_BY_NAME.PropertyManagerAccountHolder
  }, 'Property manager account holder'), /*#__PURE__*/React.createElement(ToggleButton, {
    value: USER_ROLES_BY_NAME.PropertyManagerRegular
  }, 'Property manager')))), userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, 'The Property manager account holder has full access to manage the account, including creating and deleting portfolios or properties. They can invite team members, assign them to specific portfolios, and move properties between different portfolios as needed.'))), userRole === USER_ROLES_BY_NAME.PropertyManagerRegular && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('team_page.manage_access')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Manage ".concat(dataMember.firstName, " ").concat(dataMember.lastName, "'s access to certain properties/portfolios."))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.portfoliosAccordions)
  }, !!(portfoliosData !== null && portfoliosData !== void 0 && portfoliosData.length) && !!((_portfoliosData$filte = portfoliosData.filter(portfolio => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(portfolio.name).search(searchPhrase) > 0 : true;
  })) !== null && _portfoliosData$filte !== void 0 && _portfoliosData$filte.length) ? portfoliosData.filter(portfolio => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(portfolio.name).search(searchPhrase) > 0 : true;
  }).map(portfolio => /*#__PURE__*/React.createElement(PortfolioAccordionItem, {
    key: portfolio.id,
    portfolioDataExt: portfolio,
    handleGrantAccess: handleGrantAccess,
    getIsAccessGranted: getIsAccessGranted
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      textAlign: 'center'
    }
  }, t('team_page.no_matches_found'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "portfolios or properties missing data",
    src: warningImg,
    height: '300px',
    width: '100%'
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '291-edit-teammember-modal-v2'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained"
    // disabled={!formik.isValid || !Object.keys(formik.touched).length}
    ,
    disabled: isLoading || store.portfolios.getPortfoliosDashboardAsync.inProgress,
    onClick: handleSubmit,
    'custom-attribute': '292-edit-teammember-modal-v2'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.portfolios.getPortfoliosDashboardAsync.inProgress
  }));
});